// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__2tOYu","input":"Login_input__3Wk2G","button":"Login_button__ImaPY"};